import { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Dialog } from '@myn/mui';

type Props = {
  isVersionModalOpen: boolean;
  handleCloseVersionModal: () => void;
  handleCreateNewVersion: () => void;
  handleUpdateCurrentVersion: () => void;
};

const PredictiveAcceptModal: FC<Props> = ({
  isVersionModalOpen,
  handleCloseVersionModal,
  handleCreateNewVersion,
  handleUpdateCurrentVersion,
}) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <Dialog
      open={isVersionModalOpen}
      title={t('Create a new Buying Plan version or update the current one?')}
      submitButtonProps={{
        label: t('Yes, create new'),
        onClick: handleCreateNewVersion,
      }}
      cancelButtonProps={{
        label: t('Update current'),
        onClick: handleUpdateCurrentVersion,
      }}
      onClose={handleCloseVersionModal}
    >
      {t(
        'You can create a new version now to keep track of your changes or do it later at any time.',
      )}
    </Dialog>
  );
};

export default PredictiveAcceptModal;
